import { render, staticRenderFns } from "./AccidentIntakeTreatingProvidersForm.vue?vue&type=template&id=be0d276e&scoped=true"
import script from "./AccidentIntakeTreatingProvidersForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeTreatingProvidersForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeTreatingProvidersForm.vue?vue&type=style&index=0&id=be0d276e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0d276e",
  null
  
)

export default component.exports